/* eslint-disable no-use-before-define */

/*
 * Versions of standard library functions with generics added for convenience.
 * They are *not* type safe in all situations, so make sure to read the JSDoc.
 *
 * https://alexharri.com/blog/typescript-structural-typing
 */

/**
 * A modified version of the standard Object.keys.
 * It returns the keys of the type matching the declared type of obj, instead of just strings.
 * The types are technically unsound because of how JS objects can be extended,
 * but they'll often be correct in practice. If the object has additional
 * keys that are not in the declared type, though, it will be incorrect.
 *
 * **Don't use this unless you know the keys will match the generic types!**
 *
 * https://alexharri.com/blog/typescript-structural-typing
 */
export const objectKeysUnsafe = Object.keys as <T>(obj: T) => Array<keyof T>;
